// Generated by other/sync-media-to-r2.ts. Do not edit by hand.
export type MediaAssetManifestEntry = {
	bytes: number
	key: string
	mime: string
	sha256: string
}

export const mediaAssets = {
	'/app-assets/car-media/car-bg.jpeg': {
		bytes: 145947,
		key: 'site-assets/b43dbed78a800838436ef21526ca30ad62de7ada8eadd55339179171b08e82a5/app-assets/car-media/car-bg.jpeg',
		mime: 'image/jpeg',
		sha256: 'b43dbed78a800838436ef21526ca30ad62de7ada8eadd55339179171b08e82a5',
	},
	'/app-assets/car-media/sedan-style.png': {
		bytes: 21182,
		key: 'site-assets/5612b861d6611f34e302cf1ee5390c3d5f5c1e6d1d8a0aa58cefa3e89fd384d3/app-assets/car-media/sedan-style.png',
		mime: 'image/png',
		sha256: '5612b861d6611f34e302cf1ee5390c3d5f5c1e6d1d8a0aa58cefa3e89fd384d3',
	},
	'/app-assets/favicons/apple-touch-icon.png': {
		bytes: 1566,
		key: 'site-assets/f5c9ad0f147d54b03752ddfdb54506d9d34377c17a2ca99f7883ea69b73a1101/app-assets/favicons/apple-touch-icon.png',
		mime: 'image/png',
		sha256: 'f5c9ad0f147d54b03752ddfdb54506d9d34377c17a2ca99f7883ea69b73a1101',
	},
	'/app-assets/favicons/favicon.svg': {
		bytes: 2872,
		key: 'site-assets/b9ff36740c4bc7182b606faeab320f591ee9440b1964d92130a30dcb6f0716b4/app-assets/favicons/favicon.svg',
		mime: 'image/svg+xml',
		sha256: 'b9ff36740c4bc7182b606faeab320f591ee9440b1964d92130a30dcb6f0716b4',
	},
	'/app-assets/favicons/old-apple-touch-icon.png': {
		bytes: 1215,
		key: 'site-assets/e12d191b118f19db43a87ea41130d39514380ef4a550ef3dba28c43b96725cee/app-assets/favicons/old-apple-touch-icon.png',
		mime: 'image/png',
		sha256: 'e12d191b118f19db43a87ea41130d39514380ef4a550ef3dba28c43b96725cee',
	},
	'/app-assets/favicons/old-favicon.svg': {
		bytes: 872,
		key: 'site-assets/459486eebfe7c099bfc37a08734cdac1d8a3dc2f1ee9c5bc36f7f8c038d31394/app-assets/favicons/old-favicon.svg',
		mime: 'image/svg+xml',
		sha256: '459486eebfe7c099bfc37a08734cdac1d8a3dc2f1ee9c5bc36f7f8c038d31394',
	},
	'/app-assets/logo/logo.png': {
		bytes: 14604,
		key: 'site-assets/a7be18da7b3ed0a6be673c5da316b7f7fd6a4d694ee6d6b3d66607df4b4231d1/app-assets/logo/logo.png',
		mime: 'image/png',
		sha256: 'a7be18da7b3ed0a6be673c5da316b7f7fd6a4d694ee6d6b3d66607df4b4231d1',
	},
	'/favicon.ico': {
		bytes: 1441,
		key: 'site-assets/828517f15fd79ff6865da0cbbcb742ecd1e9ef42d24affecd5d2f5c7f95167c3/favicon.ico',
		mime: 'image/x-icon',
		sha256: '828517f15fd79ff6865da0cbbcb742ecd1e9ef42d24affecd5d2f5c7f95167c3',
	},
	'/favicons/192x192.png': {
		bytes: 4275,
		key: 'site-assets/48c1b9329968203e4a7d1b6c49aceaf276b45c9297c6acc70a5bcfe4b7b3a006/favicons/192x192.png',
		mime: 'image/png',
		sha256: '48c1b9329968203e4a7d1b6c49aceaf276b45c9297c6acc70a5bcfe4b7b3a006',
	},
	'/favicons/512x512.png': {
		bytes: 15262,
		key: 'site-assets/7d1190d7d24183ecb2626224e621e1ce0d2c3dbca3b3863db4a0a8450e1cc337/favicons/512x512.png',
		mime: 'image/png',
		sha256: '7d1190d7d24183ecb2626224e621e1ce0d2c3dbca3b3863db4a0a8450e1cc337',
	},
	'/favicons/old-android-chrome-192x192.png': {
		bytes: 11229,
		key: 'site-assets/a59295550762a1f0a1a6ac70b48828517e1b87d771898f3a75003a48957f2c04/favicons/old-android-chrome-192x192.png',
		mime: 'image/png',
		sha256: 'a59295550762a1f0a1a6ac70b48828517e1b87d771898f3a75003a48957f2c04',
	},
	'/favicons/old-android-chrome-512x512.png': {
		bytes: 50083,
		key: 'site-assets/d479ea8a1127762af2b6836ff5757fa1d5f6c8df0872557024ae2a10a8e879f2/favicons/old-android-chrome-512x512.png',
		mime: 'image/png',
		sha256: 'd479ea8a1127762af2b6836ff5757fa1d5f6c8df0872557024ae2a10a8e879f2',
	},
	'/images/blog/automotive-landing-page.webp': {
		bytes: 435452,
		key: 'site-assets/b5c9f07e32fa32719e75b2fde2abec8c91a01c300f96500e6d159ac8ced4b68b/images/blog/automotive-landing-page.webp',
		mime: 'image/webp',
		sha256: 'b5c9f07e32fa32719e75b2fde2abec8c91a01c300f96500e6d159ac8ced4b68b',
	},
	'/images/blog/automotive-lead-generation.webp': {
		bytes: 370496,
		key: 'site-assets/53b8bacee4df5b25b52da2ea1d7af0f56a76705944e88b098e1d4b348ae29247/images/blog/automotive-lead-generation.webp',
		mime: 'image/webp',
		sha256: '53b8bacee4df5b25b52da2ea1d7af0f56a76705944e88b098e1d4b348ae29247',
	},
	'/images/blog/automotive-market-segmentation.webp': {
		bytes: 463968,
		key: 'site-assets/f74f86ce54a8a607489f05c066878a6c4d9d9a7353c8bdd29e96f0bda6a82f39/images/blog/automotive-market-segmentation.webp',
		mime: 'image/webp',
		sha256: 'f74f86ce54a8a607489f05c066878a6c4d9d9a7353c8bdd29e96f0bda6a82f39',
	},
	'/images/blog/automotive-marketing-trends.webp': {
		bytes: 492478,
		key: 'site-assets/d1481de25ca3f993a9520c53793e9aca7bf486a7b40ff5e4ae3b708a7d4fdc81/images/blog/automotive-marketing-trends.webp',
		mime: 'image/webp',
		sha256: 'd1481de25ca3f993a9520c53793e9aca7bf486a7b40ff5e4ae3b708a7d4fdc81',
	},
	'/images/blog/automotive-website-providers.webp': {
		bytes: 393888,
		key: 'site-assets/948bdfc45b34a41c1405509406c99914f07c5f160981f8c2419325988237c069/images/blog/automotive-website-providers.webp',
		mime: 'image/webp',
		sha256: '948bdfc45b34a41c1405509406c99914f07c5f160981f8c2419325988237c069',
	},
	'/images/blog/best-automotive-websites.webp': {
		bytes: 209316,
		key: 'site-assets/b2dae2e4ef8b70195c56ad4998d4a5f44a0c1e712e52df21807ef9d261bda78f/images/blog/best-automotive-websites.webp',
		mime: 'image/webp',
		sha256: 'b2dae2e4ef8b70195c56ad4998d4a5f44a0c1e712e52df21807ef9d261bda78f',
	},
	'/images/blog/car-dealership-advertising-ideas.webp': {
		bytes: 377654,
		key: 'site-assets/99a6abb08848e50966d1ad339cbd96e56b0483698b1b135a37fed965a7e0a655/images/blog/car-dealership-advertising-ideas.webp',
		mime: 'image/webp',
		sha256: '99a6abb08848e50966d1ad339cbd96e56b0483698b1b135a37fed965a7e0a655',
	},
	'/images/blog/car-description-examples.webp': {
		bytes: 397290,
		key: 'site-assets/a1dc589168ec7ef515bff3e04f38c621533ed7c0c6032a91e27bab0df3889456/images/blog/car-description-examples.webp',
		mime: 'image/webp',
		sha256: 'a1dc589168ec7ef515bff3e04f38c621533ed7c0c6032a91e27bab0df3889456',
	},
	'/images/blog/comprehensive-guide-automotive-lead-management.webp': {
		bytes: 369896,
		key: 'site-assets/bcfe4c5a1645d8e1d9a6077a5b742831e9a4c250dc71822ce058b5c596283258/images/blog/comprehensive-guide-automotive-lead-management.webp',
		mime: 'image/webp',
		sha256: 'bcfe4c5a1645d8e1d9a6077a5b742831e9a4c250dc71822ce058b5c596283258',
	},
	'/images/blog/cro-for-dealership-websites.webp': {
		bytes: 468114,
		key: 'site-assets/94d6085c4a91154e53b1b048dd355957c25dde4ff83c04757f94b8a674791218/images/blog/cro-for-dealership-websites.webp',
		mime: 'image/webp',
		sha256: '94d6085c4a91154e53b1b048dd355957c25dde4ff83c04757f94b8a674791218',
	},
	'/images/blog/dealerproedge-high-performance-automotive-websites-for-dealerships.webp':
		{
			bytes: 332768,
			key: 'site-assets/b05d26503af6009d31fd3a03917c34cfc967a79fc9c2d168012dca7256e56ada/images/blog/dealerproedge-high-performance-automotive-websites-for-dealerships.webp',
			mime: 'image/webp',
			sha256:
				'b05d26503af6009d31fd3a03917c34cfc967a79fc9c2d168012dca7256e56ada',
		},
	'/images/blog/dealership-local-seo.webp': {
		bytes: 529098,
		key: 'site-assets/f4f12224fe572b7344f2f7821ca95eecee5d578335001a4329d9ce31d3c1b14a/images/blog/dealership-local-seo.webp',
		mime: 'image/webp',
		sha256: 'f4f12224fe572b7344f2f7821ca95eecee5d578335001a4329d9ce31d3c1b14a',
	},
	'/images/blog/dealership-marketing.webp': {
		bytes: 384296,
		key: 'site-assets/7967817deedb460e7e2d1a0f89f5a90285d739787eee58305330104dfcc88038/images/blog/dealership-marketing.webp',
		mime: 'image/webp',
		sha256: '7967817deedb460e7e2d1a0f89f5a90285d739787eee58305330104dfcc88038',
	},
	'/images/blog/dealership-seo.webp': {
		bytes: 377538,
		key: 'site-assets/2404b328b9b8f41c12752b7382ed7b848d57568e0adc198414b02e3c281b7ff4/images/blog/dealership-seo.webp',
		mime: 'image/webp',
		sha256: '2404b328b9b8f41c12752b7382ed7b848d57568e0adc198414b02e3c281b7ff4',
	},
	'/images/blog/dealership-websites.webp': {
		bytes: 63490,
		key: 'site-assets/1d97515e3caf086a8c892f87508ce00b86519b4a5cfb94677758de94849be778/images/blog/dealership-websites.webp',
		mime: 'image/webp',
		sha256: '1d97515e3caf086a8c892f87508ce00b86519b4a5cfb94677758de94849be778',
	},
	'/images/blog/digital-marketing-for-car-dealers.webp': {
		bytes: 443116,
		key: 'site-assets/210f35739b952665fa0e68ece58a7eb3bc34cc2518183ab84d812ebb3e3bcaea/images/blog/digital-marketing-for-car-dealers.webp',
		mime: 'image/webp',
		sha256: '210f35739b952665fa0e68ece58a7eb3bc34cc2518183ab84d812ebb3e3bcaea',
	},
	'/images/blog/email-marketing-car-dealers.webp': {
		bytes: 358724,
		key: 'site-assets/7a733d238dfb530caa157232a83d95f47752933fe22488240892e3d6d3b6c074/images/blog/email-marketing-car-dealers.webp',
		mime: 'image/webp',
		sha256: '7a733d238dfb530caa157232a83d95f47752933fe22488240892e3d6d3b6c074',
	},
	'/images/blog/how-to-make-a-car-dealership-website.webp': {
		bytes: 290410,
		key: 'site-assets/06deada656b3a74658911b658c4a4e49a78e0ed1340b189fe9d9ff2f207248e1/images/blog/how-to-make-a-car-dealership-website.webp',
		mime: 'image/webp',
		sha256: '06deada656b3a74658911b658c4a4e49a78e0ed1340b189fe9d9ff2f207248e1',
	},
	'/images/blog/increase-dealership-sales-conversions.webp': {
		bytes: 205654,
		key: 'site-assets/a3b9bd0ff22a9e2a103c544bcd58c124de02f050fa8ad66d818eaa86a17e6d37/images/blog/increase-dealership-sales-conversions.webp',
		mime: 'image/webp',
		sha256: 'a3b9bd0ff22a9e2a103c544bcd58c124de02f050fa8ad66d818eaa86a17e6d37',
	},
	'/images/blog/lead-generation-for-car-dealers.webp': {
		bytes: 419340,
		key: 'site-assets/96157422cd937f9465fdc56856313149b9b319e34651392c4b76d588ab620eeb/images/blog/lead-generation-for-car-dealers.webp',
		mime: 'image/webp',
		sha256: '96157422cd937f9465fdc56856313149b9b319e34651392c4b76d588ab620eeb',
	},
	'/images/blog/local-seo-for-car-dealerships.webp': {
		bytes: 359866,
		key: 'site-assets/e17ca9b84fd043bfb5d0e904c71954dde0e6052ffbcb58220b51364fff481d0d/images/blog/local-seo-for-car-dealerships.webp',
		mime: 'image/webp',
		sha256: 'e17ca9b84fd043bfb5d0e904c71954dde0e6052ffbcb58220b51364fff481d0d',
	},
	'/images/blog/mobile-seo-for-car-dealerships.webp': {
		bytes: 332732,
		key: 'site-assets/645f6adaf3bfd89a07479c785c089a1e052c52ffd9566d1b64411a1fc2181e2c/images/blog/mobile-seo-for-car-dealerships.webp',
		mime: 'image/webp',
		sha256: '645f6adaf3bfd89a07479c785c089a1e052c52ffd9566d1b64411a1fc2181e2c',
	},
	'/images/blog/social-proof-for-dealerships.webp': {
		bytes: 393826,
		key: 'site-assets/14570d030728f3bc699d654640af68e9fa4671d9712dfd3d348c8a202548b05f/images/blog/social-proof-for-dealerships.webp',
		mime: 'image/webp',
		sha256: '14570d030728f3bc699d654640af68e9fa4671d9712dfd3d348c8a202548b05f',
	},
	'/images/car-dealer-websites/audi-rsq8-performance.png': {
		bytes: 1229456,
		key: 'site-assets/eebe99fbcabaee2e76ad20ddc48b25a09efc2f04d9852088d8d04560dfb68ed5/images/car-dealer-websites/audi-rsq8-performance.png',
		mime: 'image/png',
		sha256: 'eebe99fbcabaee2e76ad20ddc48b25a09efc2f04d9852088d8d04560dfb68ed5',
	},
	'/images/dealer-pro-edge_original-style_payload-top.svg': {
		bytes: 5066,
		key: 'site-assets/218dac08f927fa1d2d17cb2a290e9eac44ac131d02b044774957e98f087ea898/images/dealer-pro-edge_original-style_payload-top.svg',
		mime: 'image/svg+xml',
		sha256: '218dac08f927fa1d2d17cb2a290e9eac44ac131d02b044774957e98f087ea898',
	},
	'/images/dealerproedge-seo-analytics-hero.png': {
		bytes: 1341346,
		key: 'site-assets/f7b530fbf36e5a86d32f5ec78dbccea904373b21b607abed43f22ec65e979f86/images/dealerproedge-seo-analytics-hero.png',
		mime: 'image/png',
		sha256: 'f7b530fbf36e5a86d32f5ec78dbccea904373b21b607abed43f22ec65e979f86',
	},
	'/images/dealerproedge-social-preview.webp': {
		bytes: 61978,
		key: 'site-assets/4a4015385afd71990b1112c9aecde920f5106b8c4cf2bc7fd747df0e212720e7/images/dealerproedge-social-preview.webp',
		mime: 'image/webp',
		sha256: '4a4015385afd71990b1112c9aecde920f5106b8c4cf2bc7fd747df0e212720e7',
	},
	'/images/noise.png': {
		bytes: 328438,
		key: 'site-assets/b8d96ba742ae36898faa67bbeb72d090caa5cde478b572fd07bbc0615b6542fb/images/noise.png',
		mime: 'image/png',
		sha256: 'b8d96ba742ae36898faa67bbeb72d090caa5cde478b572fd07bbc0615b6542fb',
	},
	'/images/payload-home/Ai Chat.png': {
		bytes: 336913,
		key: 'site-assets/e50e10a2c5fdc4425823fbef8ef909fe9d49e4dd21495e5519de625fd7407546/images/payload-home/Ai Chat.png',
		mime: 'image/png',
		sha256: 'e50e10a2c5fdc4425823fbef8ef909fe9d49e4dd21495e5519de625fd7407546',
	},
	'/images/payload-home/Ai Description.png': {
		bytes: 1838372,
		key: 'site-assets/48bc5c7ecb735d79b3fc7853258ab7caabb483da0222526d2c02bb35890221e9/images/payload-home/Ai Description.png',
		mime: 'image/png',
		sha256: '48bc5c7ecb735d79b3fc7853258ab7caabb483da0222526d2c02bb35890221e9',
	},
	'/images/payload-home/AI Search.png': {
		bytes: 1361793,
		key: 'site-assets/6adc792eb3c0b511b1b8af9a56bfcd897f1f7f802dd8c5a1e6018cbc1f30edbc/images/payload-home/AI Search.png',
		mime: 'image/png',
		sha256: '6adc792eb3c0b511b1b8af9a56bfcd897f1f7f802dd8c5a1e6018cbc1f30edbc',
	},
	'/images/payload-home/asics-logo.svg': {
		bytes: 5078,
		key: 'site-assets/ca12dae3901f1f65e8eaf783ebffe9566742dcfd930c0ca7ae23f8496162a38e/images/payload-home/asics-logo.svg',
		mime: 'image/svg+xml',
		sha256: 'ca12dae3901f1f65e8eaf783ebffe9566742dcfd930c0ca7ae23f8496162a38e',
	},
	'/images/payload-home/backend video.png': {
		bytes: 296608,
		key: 'site-assets/acc5465de163df370032914a2886f23db012a193d6f2025c4aa9fdd29da612ce/images/payload-home/backend video.png',
		mime: 'image/png',
		sha256: 'acc5465de163df370032914a2886f23db012a193d6f2025c4aa9fdd29da612ce',
	},
	'/images/payload-home/Blasius of Bristol.png': {
		bytes: 2093747,
		key: 'site-assets/ed1327b262bd514fe7d2cab39bdd6ca72491baebe817d6f23f4742239e4b6bfe/images/payload-home/Blasius of Bristol.png',
		mime: 'image/png',
		sha256: 'ed1327b262bd514fe7d2cab39bdd6ca72491baebe817d6f23f4742239e4b6bfe',
	},
	'/images/payload-home/bugatti-white200.svg': {
		bytes: 1920,
		key: 'site-assets/485842ce28d48e3b256499428c81bc7071fd0a4e56fba4c6ddc1808118f6a24e/images/payload-home/bugatti-white200.svg',
		mime: 'image/svg+xml',
		sha256: '485842ce28d48e3b256499428c81bc7071fd0a4e56fba4c6ddc1808118f6a24e',
	},
	'/images/payload-home/cloudflareword-white200.svg': {
		bytes: 5507,
		key: 'site-assets/6e3446cdf901ee2532ae815c9f43180d92743634cca6921140ed4c549ca57da8/images/payload-home/cloudflareword-white200.svg',
		mime: 'image/svg+xml',
		sha256: '6e3446cdf901ee2532ae815c9f43180d92743634cca6921140ed4c549ca57da8',
	},
	'/images/payload-home/clubforthefuture-horizontal.svg': {
		bytes: 22153,
		key: 'site-assets/05302f0bf676b2da54f1ad1aeea3d76465fdd003ad6ba8b475f61c9c899cc423/images/payload-home/clubforthefuture-horizontal.svg',
		mime: 'image/svg+xml',
		sha256: '05302f0bf676b2da54f1ad1aeea3d76465fdd003ad6ba8b475f61c9c899cc423',
	},
	'/images/payload-home/collage.webp': {
		bytes: 435874,
		key: 'site-assets/766dc28ec775c52f0d6e7cdd78850c541e9a27b3abe2c0a9240b195c7f255133/images/payload-home/collage.webp',
		mime: 'image/webp',
		sha256: '766dc28ec775c52f0d6e7cdd78850c541e9a27b3abe2c0a9240b195c7f255133',
	},
	'/images/payload-home/config.webp': {
		bytes: 118758,
		key: 'site-assets/a350a3cbab59adbe5fef96622e80a8704fa79cf819f2c387c6f2acaeb632de77/images/payload-home/config.webp',
		mime: 'image/webp',
		sha256: 'a350a3cbab59adbe5fef96622e80a8704fa79cf819f2c387c6f2acaeb632de77',
	},
	'/images/payload-home/crt.gif': {
		bytes: 41218,
		key: 'site-assets/1e40671d6c0dcdcf911ed763dc70480a82c9f2def380fbf9072686453ce95c73/images/payload-home/crt.gif',
		mime: 'image/gif',
		sha256: '1e40671d6c0dcdcf911ed763dc70480a82c9f2def380fbf9072686453ce95c73',
	},
	'/images/payload-home/Dealer Pro Edge CMS Parts.png': {
		bytes: 3180356,
		key: 'site-assets/365f32c1008c33ce7bb30e51b9ee3f3671b1e0efb16d360b2896fb0d5696fb90/images/payload-home/Dealer Pro Edge CMS Parts.png',
		mime: 'image/png',
		sha256: '365f32c1008c33ce7bb30e51b9ee3f3671b1e0efb16d360b2896fb0d5696fb90',
	},
	'/images/payload-home/define-schema.webp': {
		bytes: 192348,
		key: 'site-assets/f1d042d63e7fd3ad7bbf2947a352251c80081f3fe9d09d327cf9277328b107ac/images/payload-home/define-schema.webp',
		mime: 'image/webp',
		sha256: 'f1d042d63e7fd3ad7bbf2947a352251c80081f3fe9d09d327cf9277328b107ac',
	},
	'/images/payload-home/DPE Backend.png': {
		bytes: 1686810,
		key: 'site-assets/ec63155ef83d6e0b37d2cb980a085aae7b0d2a853fcd99d168b0f7de6be8cfa9/images/payload-home/DPE Backend.png',
		mime: 'image/png',
		sha256: 'ec63155ef83d6e0b37d2cb980a085aae7b0d2a853fcd99d168b0f7de6be8cfa9',
	},
	'/images/payload-home/fanatics-white200.svg': {
		bytes: 6425,
		key: 'site-assets/fd46a538bf1c22b5748c2d5403074a3ab7eb5d74d3ce40bc1ae83b6c6c959862/images/payload-home/fanatics-white200.svg',
		mime: 'image/svg+xml',
		sha256: 'fd46a538bf1c22b5748c2d5403074a3ab7eb5d74d3ce40bc1ae83b6c6c959862',
	},
	'/images/payload-home/folder-structure-mockup.webp': {
		bytes: 225532,
		key: 'site-assets/7abda512fb5fea9495b162ccd9a3c21ee2ff9bcd4e5398ce8e01152186fe8960/images/payload-home/folder-structure-mockup.webp',
		mime: 'image/webp',
		sha256: '7abda512fb5fea9495b162ccd9a3c21ee2ff9bcd4e5398ce8e01152186fe8960',
	},
	'/images/payload-home/fullLogo.png': {
		bytes: 7512,
		key: 'site-assets/f20b22353dac8d9b1fe97f614b4ad40d0a0d3ab68cf549a3800cd44de67ffbef/images/payload-home/fullLogo.png',
		mime: 'image/png',
		sha256: 'f20b22353dac8d9b1fe97f614b4ad40d0a0d3ab68cf549a3800cd44de67ffbef',
	},
	'/images/payload-home/glass-animation-poster-v1.jpg': {
		bytes: 18725,
		key: 'site-assets/1c382544ccdcc275c64d5b846bcc53f87f3b4c695953ebc961f7019749887ee6/images/payload-home/glass-animation-poster-v1.jpg',
		mime: 'image/jpeg',
		sha256: '1c382544ccdcc275c64d5b846bcc53f87f3b4c695953ebc961f7019749887ee6',
	},
	'/images/payload-home/hellobello-light.png': {
		bytes: 1638,
		key: 'site-assets/2b91dd733b54c99930fb5e0fe0442787ac96076a1263094161fc8fdd5cb43666/images/payload-home/hellobello-light.png',
		mime: 'image/png',
		sha256: '2b91dd733b54c99930fb5e0fe0442787ac96076a1263094161fc8fdd5cb43666',
	},
	'/images/payload-home/hellobello-white200.svg': {
		bytes: 6799,
		key: 'site-assets/59ee68ca0d9152dcccb04ffe17532f4a9b7a44beb1502878b5cb011f386e9615/images/payload-home/hellobello-white200.svg',
		mime: 'image/svg+xml',
		sha256: '59ee68ca0d9152dcccb04ffe17532f4a9b7a44beb1502878b5cb011f386e9615',
	},
	'/images/payload-home/hero-shapes.jpg': {
		bytes: 473694,
		key: 'site-assets/ceb98ce99ee3bbf9d9c8be8537afe27417b8f50222e68d4654800bf7b48d3e40/images/payload-home/hero-shapes.jpg',
		mime: 'image/jpeg',
		sha256: 'ceb98ce99ee3bbf9d9c8be8537afe27417b8f50222e68d4654800bf7b48d3e40',
	},
	'/images/payload-home/hh-cms-new-1.png': {
		bytes: 617219,
		key: 'site-assets/a65bd979b93c9b52842083ef895ec7951afdd3aa85ca0d8b4781b47f5558de4e/images/payload-home/hh-cms-new-1.png',
		mime: 'image/png',
		sha256: 'a65bd979b93c9b52842083ef895ec7951afdd3aa85ca0d8b4781b47f5558de4e',
	},
	'/images/payload-home/hh-dam-new-1.png': {
		bytes: 642729,
		key: 'site-assets/6573f08b821bf2f910c93b7cf8b7b07804e53ffc675c96810779a53b7fba969b/images/payload-home/hh-dam-new-1.png',
		mime: 'image/png',
		sha256: '6573f08b821bf2f910c93b7cf8b7b07804e53ffc675c96810779a53b7fba969b',
	},
	'/images/payload-home/hh-ecom-1-new-dark-1.png': {
		bytes: 42748,
		key: 'site-assets/22dd8a646d46463b5ac3e37907d538bfb4d07e6567da8ceea7705c4c63e2e2aa/images/payload-home/hh-ecom-1-new-dark-1.png',
		mime: 'image/png',
		sha256: '22dd8a646d46463b5ac3e37907d538bfb4d07e6567da8ceea7705c4c63e2e2aa',
	},
	'/images/payload-home/hh-ecom-2-new-1.png': {
		bytes: 488717,
		key: 'site-assets/21d6f4caa8d5bc52f4307cfc70f841243447023b83c77cd4c7f4b3373d0f148e/images/payload-home/hh-ecom-2-new-1.png',
		mime: 'image/png',
		sha256: '21d6f4caa8d5bc52f4307cfc70f841243447023b83c77cd4c7f4b3373d0f148e',
	},
	'/images/payload-home/hh-etb-01-new-dark.png': {
		bytes: 141631,
		key: 'site-assets/9530d90a913f3176a7a21f46831e5bbcb026f9ba115574fd95438899ba65c8d1/images/payload-home/hh-etb-01-new-dark.png',
		mime: 'image/png',
		sha256: '9530d90a913f3176a7a21f46831e5bbcb026f9ba115574fd95438899ba65c8d1',
	},
	'/images/payload-home/hh-etb-02-new-dark.png': {
		bytes: 139391,
		key: 'site-assets/b806d41732704e382b202a4d06c107df72d666dc6b7328c112fdd4cc2a4248e6/images/payload-home/hh-etb-02-new-dark.png',
		mime: 'image/png',
		sha256: 'b806d41732704e382b202a4d06c107df72d666dc6b7328c112fdd4cc2a4248e6',
	},
	'/images/payload-home/hitchockmotorlogos-dark.webp': {
		bytes: 5932,
		key: 'site-assets/b09539e7474b7e0f0daba77419f3b9f98923c564339f90a0b51329390d32331a/images/payload-home/hitchockmotorlogos-dark.webp',
		mime: 'image/webp',
		sha256: 'b09539e7474b7e0f0daba77419f3b9f98923c564339f90a0b51329390d32331a',
	},
	'/images/payload-home/home-bg.png': {
		bytes: 354052,
		key: 'site-assets/c3ee2e8e73c3e0c29dabdc5054a98ca23f028c1bec6273dc118b8caaf8b60489/images/payload-home/home-bg.png',
		mime: 'image/png',
		sha256: 'c3ee2e8e73c3e0c29dabdc5054a98ca23f028c1bec6273dc118b8caaf8b60489',
	},
	'/images/payload-home/HPA Logo Transparent.png': {
		bytes: 113841,
		key: 'site-assets/84971cb4006fd349564c09df340807b68b6b473b7fd93873c70e0ebb9f022114/images/payload-home/HPA Logo Transparent.png',
		mime: 'image/png',
		sha256: '84971cb4006fd349564c09df340807b68b6b473b7fd93873c70e0ebb9f022114',
	},
	'/images/payload-home/kong-white200.svg': {
		bytes: 2163,
		key: 'site-assets/c67c72f4832732981e5831e3f948a5f3917ae8540fe7a8f3f3443b9f084bc720/images/payload-home/kong-white200.svg',
		mime: 'image/svg+xml',
		sha256: 'c67c72f4832732981e5831e3f948a5f3917ae8540fe7a8f3f3443b9f084bc720',
	},
	'/images/payload-home/link-arrow.svg': {
		bytes: 235,
		key: 'site-assets/daf78ef3694f65de28d860d4c670e369336d5e6e0295b924667f1e7d35fe4523/images/payload-home/link-arrow.svg',
		mime: 'image/svg+xml',
		sha256: 'daf78ef3694f65de28d860d4c670e369336d5e6e0295b924667f1e7d35fe4523',
	},
	'/images/payload-home/live-preview-hero.png': {
		bytes: 483392,
		key: 'site-assets/ec48bcde42714a9cfc639fbb8319cac560184f21bb0069013cce5baee2c3e738/images/payload-home/live-preview-hero.png',
		mime: 'image/png',
		sha256: 'ec48bcde42714a9cfc639fbb8319cac560184f21bb0069013cce5baee2c3e738',
	},
	'/images/payload-home/logo-dark.png': {
		bytes: 15487,
		key: 'site-assets/55ad61a76faedec6b6e84fb6456e6d04dd1015ae1ec54b5f960624fd30386b7f/images/payload-home/logo-dark.png',
		mime: 'image/png',
		sha256: '55ad61a76faedec6b6e84fb6456e6d04dd1015ae1ec54b5f960624fd30386b7f',
	},
	'/images/payload-home/mac-and-iphone-laptop.png': {
		bytes: 1570194,
		key: 'site-assets/8476f018be646625001f9bf2af34f1d022af02e6088b5b3ae149e390f32aac0e/images/payload-home/mac-and-iphone-laptop.png',
		mime: 'image/png',
		sha256: '8476f018be646625001f9bf2af34f1d022af02e6088b5b3ae149e390f32aac0e',
	},
	'/images/payload-home/microsoft-light.png': {
		bytes: 1661,
		key: 'site-assets/c8c775b8957389d37f290a0b73cacc25455005c25306b54cf172f5997b910c44/images/payload-home/microsoft-light.png',
		mime: 'image/png',
		sha256: 'c8c775b8957389d37f290a0b73cacc25455005c25306b54cf172f5997b910c44',
	},
	'/images/payload-home/microsoft-white200.svg': {
		bytes: 6293,
		key: 'site-assets/d9ce1001c9ea8b719bc72dc9c9b59c1c735d2dbb7f6909fe7d416922d50ef6be/images/payload-home/microsoft-white200.svg',
		mime: 'image/svg+xml',
		sha256: 'd9ce1001c9ea8b719bc72dc9c9b59c1c735d2dbb7f6909fe7d416922d50ef6be',
	},
	'/images/payload-home/mobile-hero-shapes.jpg': {
		bytes: 81064,
		key: 'site-assets/e312e1a1dae20f4c67b7b2d506b4885f9bacdfe35dee1b80778c51b10353c61d/images/payload-home/mobile-hero-shapes.jpg',
		mime: 'image/jpeg',
		sha256: 'e312e1a1dae20f4c67b7b2d506b4885f9bacdfe35dee1b80778c51b10353c61d',
	},
	'/images/payload-home/papertriangles-light.svg': {
		bytes: 1144,
		key: 'site-assets/ac218bcf128fc843287d3a3d4fd43e5eabbaa11e8e914eba34c1b442019f6979/images/payload-home/papertriangles-light.svg',
		mime: 'image/svg+xml',
		sha256: 'ac218bcf128fc843287d3a3d4fd43e5eabbaa11e8e914eba34c1b442019f6979',
	},
	'/images/payload-home/pedestal-mask.svg': {
		bytes: 226,
		key: 'site-assets/03abb188f78ecf1a311a06a09c1a8500e16d6732edb1ddeb5df0e39691f6cca3/images/payload-home/pedestal-mask.svg',
		mime: 'image/svg+xml',
		sha256: '03abb188f78ecf1a311a06a09c1a8500e16d6732edb1ddeb5df0e39691f6cca3',
	},
	'/images/payload-home/scanline-dark.png': {
		bytes: 82,
		key: 'site-assets/21c26f4df93c2f0dc9a8749330cb08abe902d79ef6512c6e463b05c5564868e0/images/payload-home/scanline-dark.png',
		mime: 'image/png',
		sha256: '21c26f4df93c2f0dc9a8749330cb08abe902d79ef6512c6e463b05c5564868e0',
	},
	'/images/payload-home/scanline-light.png': {
		bytes: 83,
		key: 'site-assets/3d4532452ae63a89744763fdde15260c1be35dd93cb7271a4aeceac32f30f985/images/payload-home/scanline-light.png',
		mime: 'image/png',
		sha256: '3d4532452ae63a89744763fdde15260c1be35dd93cb7271a4aeceac32f30f985',
	},
	'/images/payload-home/screen-mask.svg': {
		bytes: 210,
		key: 'site-assets/ed4435482ac39ee422c4fb8bc8373f6f1fe75183d0c13e774f8dea2e4e0ff7dc/images/payload-home/screen-mask.svg',
		mime: 'image/svg+xml',
		sha256: 'ed4435482ac39ee422c4fb8bc8373f6f1fe75183d0c13e774f8dea2e4e0ff7dc',
	},
	'/images/payload-home/sonos-white200.svg': {
		bytes: 4403,
		key: 'site-assets/8f099cc2a94c43e293e5e029992cc0cec01aae046d5221ca473b62e09c7fb869/images/payload-home/sonos-white200.svg',
		mime: 'image/svg+xml',
		sha256: '8f099cc2a94c43e293e5e029992cc0cec01aae046d5221ca473b62e09c7fb869',
	},
	'/images/payload-home/tekton-light.png': {
		bytes: 1133,
		key: 'site-assets/0eda53581f203b8f3f672fc12569a1df5a96a56b0969c0b8c7fd1b8b78f309e4/images/payload-home/tekton-light.png',
		mime: 'image/png',
		sha256: '0eda53581f203b8f3f672fc12569a1df5a96a56b0969c0b8c7fd1b8b78f309e4',
	},
	'/images/payload-home/usaf-white200.svg': {
		bytes: 6325,
		key: 'site-assets/ca10cc051d3d2bf622601db0844f6717b84885c57b189479ff730dd672a2932d/images/payload-home/usaf-white200.svg',
		mime: 'image/svg+xml',
		sha256: 'ca10cc051d3d2bf622601db0844f6717b84885c57b189479ff730dd672a2932d',
	},
	'/images/payload-home/vector-database.webp': {
		bytes: 480046,
		key: 'site-assets/ed3c15f16a748bc1eee646d12ad48bd4eda8bc71c4b27afee4d0cf05fe7fe72c/images/payload-home/vector-database.webp',
		mime: 'image/webp',
		sha256: 'ed3c15f16a748bc1eee646d12ad48bd4eda8bc71c4b27afee4d0cf05fe7fe72c',
	},
	'/images/payload-home/vehicle_inventory_dashboard_actual_transparent.png': {
		bytes: 4206450,
		key: 'site-assets/d3e9eb19dae704c4e2bf238d28de26d5f092a3862af24dc605538eaf0b614b48/images/payload-home/vehicle_inventory_dashboard_actual_transparent.png',
		mime: 'image/png',
		sha256: 'd3e9eb19dae704c4e2bf238d28de26d5f092a3862af24dc605538eaf0b614b48',
	},
	'/images/payload-home/visual-editing.webp': {
		bytes: 126092,
		key: 'site-assets/9eb7a9036c0d9f15cfc593eb11e1089be7bb2f171f9b509229cb102e65a4dd41/images/payload-home/visual-editing.webp',
		mime: 'image/webp',
		sha256: '9eb7a9036c0d9f15cfc593eb11e1089be7bb2f171f9b509229cb102e65a4dd41',
	},
	'/images/payload-home/writing-assistant-light-updated.webp': {
		bytes: 245746,
		key: 'site-assets/88a8f27eb6b2db7428874978285d3b9ce727010066ea8d9677a7e319e46ea3a7/images/payload-home/writing-assistant-light-updated.webp',
		mime: 'image/webp',
		sha256: '88a8f27eb6b2db7428874978285d3b9ce727010066ea8d9677a7e319e46ea3a7',
	},
	'/images/payload-mask.svg': {
		bytes: 8656,
		key: 'site-assets/c584b929fbce16ba4607197a0d459e89a11f82f871bf2855f278c6f61cb23e48/images/payload-mask.svg',
		mime: 'image/svg+xml',
		sha256: 'c584b929fbce16ba4607197a0d459e89a11f82f871bf2855f278c6f61cb23e48',
	},
	'/images/testimonials/bill-palomba.png': {
		bytes: 124128,
		key: 'site-assets/e0b6483d54e21c2ae339a0408f91399adde69543115211659d57cfb936c853c6/images/testimonials/bill-palomba.png',
		mime: 'image/png',
		sha256: 'e0b6483d54e21c2ae339a0408f91399adde69543115211659d57cfb936c853c6',
	},
	'/images/testimonials/larry-perry.png': {
		bytes: 139221,
		key: 'site-assets/4acd436958a7d9e6c0321df84f55d016a4051d7f4f17ec187753eb1b5827a237/images/testimonials/larry-perry.png',
		mime: 'image/png',
		sha256: '4acd436958a7d9e6c0321df84f55d016a4051d7f4f17ec187753eb1b5827a237',
	},
	'/images/testimonials/mike-phelan.jpg': {
		bytes: 18926,
		key: 'site-assets/3867564a2d471d1e4334ed84f2265ca8aca6d4a535197d29f930e0f7c5b20519/images/testimonials/mike-phelan.jpg',
		mime: 'image/jpeg',
		sha256: '3867564a2d471d1e4334ed84f2265ca8aca6d4a535197d29f930e0f7c5b20519',
	},
	'/img/noise.webp': {
		bytes: 732274,
		key: 'site-assets/6f874a8481dc41fe2793f9e0da09de58d5d392a576a3e6c008af221b82c6e24b/img/noise.webp',
		mime: 'image/webp',
		sha256: '6f874a8481dc41fe2793f9e0da09de58d5d392a576a3e6c008af221b82c6e24b',
	},
	'/img/user.png': {
		bytes: 3012,
		key: 'site-assets/4a724f5c32ea4ca7d8dd8702842808733a239299ce82f7be9bd34e3b69accbfa/img/user.png',
		mime: 'image/png',
		sha256: '4a724f5c32ea4ca7d8dd8702842808733a239299ce82f7be9bd34e3b69accbfa',
	},
	'/old-favicon.ico': {
		bytes: 42806,
		key: 'site-assets/96b8fd6644db77cf21aa4b24f1d40424d33b5b32237eab5722dc67dee8197aa1/old-favicon.ico',
		mime: 'image/x-icon',
		sha256: '96b8fd6644db77cf21aa4b24f1d40424d33b5b32237eab5722dc67dee8197aa1',
	},
} as const satisfies Record<string, MediaAssetManifestEntry>
